const parseFloatToFixed = (value: string | null | undefined, fractionDigicts?: number | undefined): string =>
  parseFloat(value ?? '0').toFixed(fractionDigicts);

export default parseFloatToFixed;
